import {
  createRouter,
  createRoute,
  createRootRoute,
  Outlet,
} from '@tanstack/react-router';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Pipeline } from './pages/Pipeline';
import { Leads } from './pages/Leads';
import { Contacts } from './pages/Contacts';
import { Tasks } from './pages/Tasks';
import { Settings } from './pages/Settings';
import { Prospects } from './pages/Prospects';
import { Emails } from './pages/Emails';
import {
  MarketingOverview,
  Campaigns,
  ContentLibrary,
  SocialPosts,
  ContentCalendar,
} from './pages/marketing';

// Root route with layout
const rootRoute = createRootRoute({
  component: () => (
    <Layout>
      <Outlet />
    </Layout>
  ),
});

// Dashboard
const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Dashboard,
});

// Pipeline
const pipelineRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pipeline',
  component: Pipeline,
});

// Leads
const leadsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/leads',
  component: Leads,
});

// Contacts
const contactsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contacts',
  component: Contacts,
});

// Prospects (Construction Directory)
const prospectsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/prospects',
  component: Prospects,
});

// Tasks
const tasksRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tasks',
  component: Tasks,
});

// Emails
const emailsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/emails',
  component: Emails,
});

// Marketing routes
const marketingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/marketing',
  component: MarketingOverview,
});

const campaignsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/marketing/campaigns',
  component: Campaigns,
});

const contentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/marketing/content',
  component: ContentLibrary,
});

const socialRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/marketing/social',
  component: SocialPosts,
});

const calendarRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/marketing/calendar',
  component: ContentCalendar,
});

// Settings
const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  component: Settings,
});

// Create router
const routeTree = rootRoute.addChildren([
  dashboardRoute,
  pipelineRoute,
  leadsRoute,
  contactsRoute,
  prospectsRoute,
  tasksRoute,
  emailsRoute,
  marketingRoute,
  campaignsRoute,
  contentRoute,
  socialRoute,
  calendarRoute,
  settingsRoute,
]);

export const router = createRouter({ routeTree });

// Type declaration for router
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
